import { useTranslation } from 'react-i18next';
import { AreaRecordRow } from './AreaRecordRow';
import type { IAreaRecordListProps } from './IAreaRecordListProps';

/** Список записів огляду напряму (прототип v4): підпис 12px 700 великими літерами в акцентному кольорі й картка рядків; порожньо — «Тут порожньо.». */
export function AreaRecordList({ title, ws, records, today }: IAreaRecordListProps) {
  const { t } = useTranslation();
  return (
    <section className="ar-section" aria-label={title}>
      <span className="ar-label">{title}</span>
      <div className="ar-list">
        {records.map((r) => <AreaRecordRow key={`${r.recordType}:${r.id}`} ws={ws} record={r} today={today} />)}
        {!records.length && <div className="ar-empty">{t('areaPage.nothing')}</div>}
      </div>
    </section>
  );
}
